import * as yup from 'yup'

export const estateProjectSchema = yup
  .object({
    project_name: yup.string().required('Vui lòng nhập tên dự án'),
    project_address: yup.string().required('Vui lòng nhập địa chỉ dự án'),
    lat: yup.number().typeError('Thiếu tọa độ vĩ độ').required('Thiếu tọa độ vĩ độ'),
    lng: yup.number().typeError('Thiếu tọa độ kinh độ').required('Thiếu tọa độ kinh độ'),
    polygon_geojson: yup
      .object()
      .required('Vui lòng vẽ polygon')
      .test('polygon-shape', 'Polygon phải có tối thiểu 3 điểm', (value: any) => {
        const ring = value?.coordinates?.[0] || []
        return Array.isArray(ring) && ring.length >= 4
      }),
    investor: yup
      .object()
      .required('Vui lòng chọn chủ đầu tư')
      .test('investor-id', 'Vui lòng chọn chủ đầu tư', (value: any) => !!value?.id),
    project_information: yup
      .array()
      .of(
        yup.object({
          key: yup.string().trim().required('Không để trống key'),
          value: yup.string().trim().nullable(),
        }),
      )
      .min(1, 'Cần ít nhất 1 dòng thông tin dự án'),
    description: yup.string().required('Vui lòng nhập mô tả'),
    photos: yup.array(),
    videos: yup.array(),
    logo: yup
      .object()
      .nullable()
      .required('Vui lòng chọn logo dự án')
      .test('logo-uuid', 'Vui lòng chọn logo dự án', (value: any) => !!value?.uuid),
  })
  .test('media-required', 'Vui lòng chọn ít nhất 1 ảnh hoặc video', (value: any) => {
    const photoCount = Array.isArray(value?.photos) ? value.photos.length : 0
    const videoCount = Array.isArray(value?.videos) ? value.videos.length : 0
    return photoCount + videoCount > 0
  })
